module.exports = __webpack_public_path__ + "static/media/home-office.eeb8a58f.svg";